module.exports = __webpack_public_path__ + "static/img/ic_double_pay.2be1e9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welfare/ic_double_pay.png
// module id = dD7D
// module chunks = 1